/* Component in the BgPage component to display the Callsheet 
   Background items 
 * Contains the BackgroundInfo component to display 
   the extra background info 
 * Contains the BgInfoMob component to display 
   the extra background info in mobile */
import React from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import styles from "../../../styles/Callsheets.module.css"

const Location2 = (props) => {

  const {scene, style, index} = props;
  const name = scene.filming_location;
  const address = scene.location_address;
  const parkNotes = scene.time;

  // const location_map_address = `${name}, ${address}`; 

  return (
    <div style={style}>
    <Row className='px-3'>
    <Col className={`mx-0 px-0 px-md-3 py-1 ${styles.BorderLoc}`} xs={1} >
    <p className={`mb-0 text-center ${styles.Bold}`}>{index+1}</p>
    </Col>
    <Col className={`mx-0 px-1 px-md-3 py-1 ${styles.BorderLoc}`} xs={5} md={5}>
    <p className={`mb-0 ${styles.Bold}`} >{name}</p>
    <p className='mb-0'>{address}</p>
    </Col>
    <Col className={`mx-0 px-1 px-md-3 py-1 ${styles.BorderLoc}`} xs={6} md={6}>
    <p className={`mb-0`}>{parkNotes}</p>
    </Col>
    </Row>
    </div>
  )
}

export default Location2